import { render, staticRenderFns } from "./QuoteWizardModuleConfigurator.vue?vue&type=template&id=1c40a7fb&"
import script from "./QuoteWizardModuleConfigurator.vue?vue&type=script&lang=ts&"
export * from "./QuoteWizardModuleConfigurator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports